export default function autoScroll(options = {}) {

    const {
        selector = '.scroller',
        initialSpeed = 0,
        maxSpeed = 1,
        accelerationDuration = 2000, 
        userPauseDelay = 3000,  
    } = options;

    const element = document.querySelector(selector);
    if (!element) return;

    let isScrolling = true;
    let startTime = null;
    const isVertical = element.scrollHeight > element.scrollWidth;
    let isProgrammaticScroll = false;
    let userInteractionTimeout;

    function scroll(timestamp) {

        if( element.classList.contains('fixed-grid') && window.innerWidth >= 659){
            return;
        }

        if (!isScrolling) return;

        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;

        // Calculate progress [0,1] and apply easing
        const progress = Math.min(elapsed / accelerationDuration, 1);
        const easedProgress = easeInOutCubic(progress);

        // Determine current speed
        const currentSpeed = initialSpeed + (maxSpeed - initialSpeed) * easedProgress;

        // Indicate that the scroll is programmatic
        isProgrammaticScroll = true;

        // Scroll the element
        if (isVertical) {
            element.scrollBy({
                top: currentSpeed,
                behavior: 'instant'
            });
        } else {

            element.scrollBy({
                left:currentSpeed,
                behavior: 'instant'
            });
        }

        requestAnimationFrame(scroll);

    }

    requestAnimationFrame(scroll);

    function onUserInteraction() {

        clearTimeout(userInteractionTimeout);
        if (isScrolling) {
            isScrolling = false;
            startTime = null; 
        }

        // Resume auto-scroll after a delay
        userInteractionTimeout = setTimeout(() => {
            isScrolling = true;
            requestAnimationFrame(scroll);
        }, userPauseDelay);

    }

    document.addEventListener('wheel', onUserInteraction, { passive: true });
    document.addEventListener('touchstart', onUserInteraction, { passive: true });
    document.addEventListener('keydown', onUserInteraction);
    document.addEventListener('mousedown', onUserInteraction);
    document.addEventListener('mousemove', onUserInteraction);

    // Easing function for smooth acceleration
    function easeInOutCubic(t) {
        return t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
}
